(() => {
const $7313ba2f322ffb68$var$selector = '.reveal-image .reveal-image__container';
const $7313ba2f322ffb68$var$calculateRadius = ()=>{
    const revelImageCtr = document.querySelectorAll($7313ba2f322ffb68$var$selector);
    revelImageCtr.forEach((ctr)=>{
        const img = ctr.querySelector('img');
        const radius = Math.sqrt(Math.pow(img.width, 2) + Math.pow(img.height, 2));
        ctr.style.setProperty('--radius', `${radius}px`);
    });
};
window.addEventListener('load', $7313ba2f322ffb68$var$calculateRadius);
window.addEventListener('resize', $7313ba2f322ffb68$var$calculateRadius);

})();
//# sourceMappingURL=reveal_image.min.js.map
